import styled from 'styled-components'
import { Form } from 'formik'

import { breakpoints, colors } from '@/styles'
import { Group, Label, Row } from '@/components/form'

const StyledGroup = styled(Group)`
  margin: 0;
  position: relative;
  @media screen and (max-width: ${breakpoints.phoneMax}) {
    flex: 0 0 100%;
    max-width: 100%;
    padding: 0;
  }
`
const ToggleGroup = styled(StyledGroup)`
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    justify-content: space-between;
  }
`
const ToggleLabel = styled(Label)<{ left?: boolean }>`
  margin-right: ${props => (props.left ? '0' : '15px')};
  margin-left: ${props => (props.left ? '15px' : '0')};
  margin-bottom: 0;

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    padding-left: 0 !important;
  }
`
const StyledRow = styled(Row)`
  @media screen and (max-width: ${breakpoints.phoneMax}) {
    flex-direction: column;
    gap: 16px;
    padding: 0 16px;
    margin: 0;
  }
`
const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`
const StyledForm = styled(Form)`
  display: flex;
  flex-direction: column;
  gap: 20px;
`
const Divider = styled.div`
  background-color: ${colors.grey88};
  height: 1px;
  padding: 0;
  margin: 0;
  width: 100%;
`

export {
  StyledGroup,
  StyledRow,
  ToggleGroup,
  ToggleLabel,
  IconWrapper,
  StyledForm,
  Divider
}
